<template>
    <div>
        <b-modal
            id="modalNotaFiscalForm"
            v-model="mostrarModal"
            size="lg"
            @show="abrirNotaFiscalForm()"
            @hide="resetNotaFiscalForm()"
        >
            <div slot="modal-title">
                Pagamento - Nota Fiscal -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>

            <h6 class="text-primary">Dados da Nota</h6>
            <b-row>
                <b-col sm="4">
                    <b-form-group>
                        <label class="required">Número da NF</label>
                        <b-form-input
                            type="text"
                            v-model="numeroNota"
                            @input="$v.numeroNota.$touch()"
                            :state="$v.numeroNota.$error ? false : null"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >O número da nota fiscal é obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <label class="required">Data Emissão</label>
                        <date-picker
                            id="dataEmissaoNotaFiscal"
                            v-model="dataEmissao"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input="$v.dataEmissao.$touch()"
                            :disabled="somenteLeitura"
                        ></date-picker>
                        <b-form-invalid-feedback
                            :state="$v.dataEmissao.$error ? false : null"
                            >A data de emissão é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="4">
                    <b-form-group>
                        <label>Mês de Competência</label>
                        <b-form-input
                            type="text"
                            v-model="mesCompetencia"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="operacao === 'INSERIR'">
                <b-col sm="6">
                    <b-form-group>
                        <label>Valor da Nota</label>
                        <b-form-input
                            type="number"
                            step="0.01"
                            v-model="valorNota"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group>
                        <label>Local de Prestação</label>
                        <b-form-input
                            type="text"
                            v-model="localPrestacao"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label class="required">Descrição da Nota</label>
                        <b-form-textarea
                            v-model="descricaoNota"
                            @input="$v.descricaoNota.$touch()"
                            :state="$v.descricaoNota.$error ? false : null"
                            :disabled="somenteLeitura"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição da nota é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>

            <h6 class="text-primary mt-2">Prestador</h6>
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label class="required">Razão Social</label>
                        <b-form-input
                            type="text"
                            v-model="prestadorRazaoSocial"
                            @input="$v.prestadorRazaoSocial.$touch()"
                            :state="$v.prestadorRazaoSocial.$error ? false : null"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                        <b-form-invalid-feedback
                            >A razão social do prestador é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>CNPJ/CPF</label>
                        <b-form-input
                            type="text"
                            v-model="prestadorCnpjCpf"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>E-mail</label>
                        <b-form-input
                            type="text"
                            v-model="prestadorEmail"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-checkbox
                        v-model="prestadorOptanteSimples"
                        :disabled="somenteLeitura"
                    >
                        Optante pelo Simples Nacional
                    </b-form-checkbox>
                </b-col>
            </b-row>

            <h6 class="text-primary mt-2">Tomador</h6>
            <b-row>
                <b-col sm="6">
                    <b-form-group>
                        <label>Razão Social</label>
                        <b-form-input
                            type="text"
                            v-model="tomadorRazaoSocial"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>CNPJ/CPF</label>
                        <b-form-input
                            type="text"
                            v-model="tomadorCnpjCpf"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="3">
                    <b-form-group>
                        <label>E-mail</label>
                        <b-form-input
                            type="text"
                            v-model="tomadorEmail"
                            :disabled="somenteLeitura"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <div v-if="operacao === 'ATUALIZAR'">
                <h6 class="text-primary mt-2">Valores e Tributos</h6>
                <b-row>
                    <b-col sm="4">
                        <b-form-group>
                            <label>Valor do Serviço</label>
                            <b-form-input type="number" step="0.01" v-model="valorServico" :disabled="somenteLeitura"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group>
                            <label>Valor de Dedução</label>
                            <b-form-input type="number" step="0.01" v-model="valorDeducao" :disabled="somenteLeitura"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="2" v-for="imposto in impostos" :key="imposto.chave">
                        <b-form-group>
                            <label>{{ imposto.label }} (%)</label>
                            <b-form-input type="number" step="0.01" v-model="imposto.aliquota.value" :disabled="somenteLeitura"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="2" v-for="imposto in impostos" :key="imposto.chave + '_valor'">
                        <b-form-group>
                            <label>Valor {{ imposto.label }}</label>
                            <b-form-input type="number" step="0.01" v-model="imposto.valor.value" :disabled="somenteLeitura"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>

            <b-row v-if="operacao === 'INSERIR'">
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo da Nota Fiscal</label>
                        <b-form-file
                            v-model="arquivo"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecionar"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharNotaFiscalForm()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid || somenteLeitura"
                    @click.stop="salvarNotaFiscal()"
                    class="ml-2"
                    v-if="!somenteLeitura"
                    >Salvar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'pagamento-nota-fiscal-form',

    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        },

        operacao: {
            type: String,
            default: () => 'INSERIR'
        },

        notaFiscalAtualizarId: {
            type: String,
            default: null
        },

        somenteLeitura: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            obterPagamentoAtualizado: false,
            pagamentoNotaFiscalId: null,
            numeroNota: '',
            dataEmissao: null,
            mesCompetencia: '',
            valorNota: null,
            localPrestacao: '',
            descricaoNota: '',
            prestadorRazaoSocial: '',
            prestadorCnpjCpf: '',
            prestadorEmail: '',
            prestadorOptanteSimples: false,
            tomadorRazaoSocial: '',
            tomadorCnpjCpf: '',
            tomadorEmail: '',
            valorServico: null,
            valorDeducao: null,
            valorIss: null,
            valorPis: null,
            valorCofins: null,
            valorInss: null,
            valorIr: null,
            valorCsll: null,
            aliquotaIss: null,
            aliquotaPis: null,
            aliquotaCofins: null,
            aliquotaInss: null,
            aliquotaIr: null,
            aliquotaCsll: null,
            arquivo: null
        }
    },

    computed: {
        impostos() {
            return [
                { chave: 'iss', label: 'ISS', valor: this.campo('valorIss'), aliquota: this.campo('aliquotaIss') },
                { chave: 'pis', label: 'PIS', valor: this.campo('valorPis'), aliquota: this.campo('aliquotaPis') },
                { chave: 'cofins', label: 'COFINS', valor: this.campo('valorCofins'), aliquota: this.campo('aliquotaCofins') },
                { chave: 'inss', label: 'INSS', valor: this.campo('valorInss'), aliquota: this.campo('aliquotaInss') },
                { chave: 'ir', label: 'IR', valor: this.campo('valorIr'), aliquota: this.campo('aliquotaIr') },
                { chave: 'csll', label: 'CSLL', valor: this.campo('valorCsll'), aliquota: this.campo('aliquotaCsll') }
            ]
        }
    },

    methods: {
        campo(nome) {
            const self = this
            return {
                get value() {
                    return self[nome]
                },
                set value(v) {
                    self[nome] = v
                }
            }
        },

        abrirNotaFiscalForm() {
            this.obterPagamentoAtualizado = false
            if (this.operacao === 'ATUALIZAR' && this.notaFiscalAtualizarId) {
                this.obterNotaFiscal()
            }
        },

        fecharNotaFiscalForm() {
            this.mostrarModal = false
            if (this.obterPagamentoAtualizado) {
                this.$emit('obterPagamentoAtualizado')
            }
        },

        resetNotaFiscalForm() {
            this.pagamentoNotaFiscalId = null
            this.numeroNota = ''
            this.dataEmissao = null
            this.mesCompetencia = ''
            this.valorNota = null
            this.localPrestacao = ''
            this.descricaoNota = ''
            this.prestadorRazaoSocial = ''
            this.prestadorCnpjCpf = ''
            this.prestadorEmail = ''
            this.prestadorOptanteSimples = false
            this.tomadorRazaoSocial = ''
            this.tomadorCnpjCpf = ''
            this.tomadorEmail = ''
            this.valorServico = null
            this.valorDeducao = null
            this.valorIss = null
            this.valorPis = null
            this.valorCofins = null
            this.valorInss = null
            this.valorIr = null
            this.valorCsll = null
            this.aliquotaIss = null
            this.aliquotaPis = null
            this.aliquotaCofins = null
            this.aliquotaInss = null
            this.aliquotaIr = null
            this.aliquotaCsll = null
            this.arquivo = null
            this.erros = []
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        preencherForm(notaFiscal) {
            this.pagamentoNotaFiscalId = notaFiscal.pagamentoNotaFiscalId
            this.numeroNota = notaFiscal.numeroNota
            this.dataEmissao = notaFiscal.dataEmissao ? this.$moment(notaFiscal.dataEmissao).format('DD/MM/YYYY') : null
            this.mesCompetencia = notaFiscal.mesCompetencia
            this.valorNota = notaFiscal.valorNota
            this.localPrestacao = notaFiscal.localPrestacao
            this.descricaoNota = notaFiscal.descricaoNota
            this.prestadorRazaoSocial = notaFiscal.prestadorRazaoSocial
            this.prestadorCnpjCpf = notaFiscal.prestadorCnpjCpf
            this.prestadorEmail = notaFiscal.prestadorEmail
            this.prestadorOptanteSimples = notaFiscal.prestadorOptanteSimples
            this.tomadorRazaoSocial = notaFiscal.tomadorRazaoSocial
            this.tomadorCnpjCpf = notaFiscal.tomadorCnpjCpf
            this.tomadorEmail = notaFiscal.tomadorEmail
            this.valorServico = notaFiscal.valorServico
            this.valorDeducao = notaFiscal.valorDeducao
            this.valorIss = notaFiscal.valorIss
            this.valorPis = notaFiscal.valorPis
            this.valorCofins = notaFiscal.valorCofins
            this.valorInss = notaFiscal.valorInss
            this.valorIr = notaFiscal.valorIr
            this.valorCsll = notaFiscal.valorCsll
            this.aliquotaIss = notaFiscal.aliquotaIss
            this.aliquotaPis = notaFiscal.aliquotaPis
            this.aliquotaCofins = notaFiscal.aliquotaCofins
            this.aliquotaInss = notaFiscal.aliquotaInss
            this.aliquotaIr = notaFiscal.aliquotaIr
            this.aliquotaCsll = notaFiscal.aliquotaCsll
        },

        obterNotaFiscal() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos.obterNotaFiscal(this.notaFiscalAtualizarId).then(response => {
                if (response && response.success) {
                    this.preencherForm(response.data)
                } else {
                    this.$toast.error(
                        'Erro ao obter a nota fiscal!!!',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarNotaFiscal() {
            this.mostrarModal = false
            this.$store.dispatch('addRequest')

            const dataEmissaoIso = this.dataEmissao
                ? this.$moment(this.dataEmissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
                : null

            let salvar = null

            if (this.operacao === 'ATUALIZAR') {
                const notaFiscalData = {
                    pagamentoNotaFiscalId: this.pagamentoNotaFiscalId,
                    pagamentoId: this.pagamento.pagamentoId,
                    numeroNota: this.numeroNota,
                    dataEmissao: dataEmissaoIso,
                    mesCompetencia: this.mesCompetencia,
                    descricaoNota: this.descricaoNota,
                    valorServico: this.valorServico,
                    valorDeducao: this.valorDeducao,
                    valorIss: this.valorIss,
                    valorPis: this.valorPis,
                    valorCofins: this.valorCofins,
                    valorInss: this.valorInss,
                    valorIr: this.valorIr,
                    valorCsll: this.valorCsll,
                    aliquotaIss: this.aliquotaIss,
                    aliquotaPis: this.aliquotaPis,
                    aliquotaCofins: this.aliquotaCofins,
                    aliquotaInss: this.aliquotaInss,
                    aliquotaIr: this.aliquotaIr,
                    aliquotaCsll: this.aliquotaCsll,
                    prestadorOptanteSimples: this.prestadorOptanteSimples,
                    prestadorCnpjCpf: this.prestadorCnpjCpf,
                    prestadorRazaoSocial: this.prestadorRazaoSocial,
                    prestadorEmail: this.prestadorEmail,
                    tomadorCnpjCpf: this.tomadorCnpjCpf,
                    tomadorRazaoSocial: this.tomadorRazaoSocial,
                    tomadorEmail: this.tomadorEmail
                }
                salvar = this.pagamentosServicos.atualizarNotaFiscal(notaFiscalData)
            } else {
                const notaFiscalData = {
                    pagamentoId: this.pagamento.pagamentoId,
                    numeroNota: this.numeroNota,
                    dataEmissao: dataEmissaoIso,
                    mesCompetencia: this.mesCompetencia,
                    valorNota: this.valorNota,
                    localPrestacao: this.localPrestacao,
                    descricaoNota: this.descricaoNota,
                    prestadorRazaoSocial: this.prestadorRazaoSocial,
                    prestadorCnpjCpf: this.prestadorCnpjCpf,
                    prestadorEmail: this.prestadorEmail,
                    prestadorOptanteSimples: this.prestadorOptanteSimples,
                    tomadorRazaoSocial: this.tomadorRazaoSocial,
                    tomadorCnpjCpf: this.tomadorCnpjCpf,
                    tomadorEmail: this.tomadorEmail,
                    arquivo: this.arquivo
                }
                salvar = this.pagamentosServicos.inserirPagamentoNotaFiscal(notaFiscalData)
            }

            salvar.then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Nota fiscal salva com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterPagamentoAtualizado = true
                        this.resetNotaFiscalForm()
                        this.fecharNotaFiscalForm()
                    } else {
                        this.erros = response.errors
                        this.mostrarModal = true
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    validations: {
        numeroNota: { required },
        dataEmissao: { required },
        descricaoNota: { required },
        prestadorRazaoSocial: { required }
    }
}
</script>
